import { Form, Input, Spin, message, Button, DatePicker } from "antd";
import { useState } from "react";
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";

const CreateBlogPage = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const blogData = {
        ...values,
        publishedDate: values.publishedDate.format('YYYY-MM-DD'), // Tarihi uygun formata çevir
      };
      const response = await fetch(`${apiUrl}/api/blogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(blogData),
      });
      if (response.ok) {
        message.success("Blog başarıyla oluşturuldu.");
        form.resetFields();
      } else {
        message.error("Blog oluşturulurken bir hata oluştu.");
      }
    } catch (error) {
      console.log("Blog oluşturma hatası:", error);
      message.error("Blog oluşturulurken bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form name="basic" layout="vertical" onFinish={onFinish} form={form}>
        {/* Blog Başlığı */}
        <Form.Item
          label="Blog Başlığı"
          name="name"
          rules={[{ required: true, message: "Lütfen blog başlığını girin!" }]}
        >
          <Input placeholder="Blog başlığını girin" />
        </Form.Item>
        
        {/* Yayın Tarihi */}
        <Form.Item
          label="Yayın Tarihi"
          name="publishedDate"
          rules={[{ required: true, message: "Lütfen blog yayın tarihini seçin!" }]}
        >
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>
        
        {/* Blog Görseli (Link) */}
        <Form.Item
          label="Blog Görseli (Link)"
          name="img"
          rules={[{ required: true, message: "Lütfen blog görselinin linkini girin!" }]}
        >
          <Input placeholder="Blog görseli için link girin" />
        </Form.Item>
        
        {/* Blog Açıklaması */}
        <Form.Item
          label="Blog Açıklaması"
          name="description"
          rules={[{ required: true, message: "Lütfen açıklama girin!" }]}
        >
          <ReactQuill theme="snow" placeholder="Blog açıklamasını yazın" style={{ backgroundColor: "white" }} />
        </Form.Item>
        
        {/* Blog Yazısı */}
        <Form.Item
          label="Blog Yazısı"
          name="content"
          rules={[{ required: true, message: "Lütfen Blog Yazınızı Yazın!" }]}
        >
          <ReactQuill theme="snow" placeholder="Blog yazınızı yazın" style={{ backgroundColor: "white" }} />
        </Form.Item>
        
        {/* Blog Oluşturma Butonu */}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Oluştur
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default CreateBlogPage;
